export default {
	addCity: 'die Stadt hinzufügen',
	city: 'Stadt',
	country: 'Land',
	countryRequired: 'Land',
	options: 'Optionen',
	edit: 'Ändern',
	editingCity: 'die Stadt ändern',
	areYouSureYouWantToDeleteCity: 'Wollen Sie wirklich die Stadt löschen?',
	cityCenterCoordinates: 'Koordinaten des Stadtzentrums',
	latitude: 'Breite',
	longitude: 'Längengrad'
};
